module.exports = __webpack_public_path__ + "img/camera-circled.ee68d265.svg";